function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.636 10.856a8.065 8.065 0 003.509 3.509l1.171-1.171a.53.53 0 01.543-.128c.597.197 1.24.303 1.9.303.294 0 .533.24.533.533v1.858c0 .293-.24.532-.532.532-5 0-9.051-4.051-9.051-9.05 0-.293.24-.533.532-.533h1.864c.293 0 .532.24.532.532 0 .666.107 1.305.304 1.901a.534.534 0 01-.133.543l-1.172 1.171z",
  fill: "#fff"
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none"
  }, props), _ref);
}

export default SvgPhone;